import { Observable } from 'rxjs';

import { Injectable, InjectionToken } from '@angular/core';

import { AuthenticatedUser } from '../model/authentication/authenticated-user.model';
import { TokenResult } from '../model/token-result.model';
import { ApiConfigService } from '../service/api-config.service';
import { AuthenticationService } from '../service/authentication.service';
import { UserCredentialService } from '../service/user-credential.service';

export interface IJwtHttpIntConfig {
  loginUrl: string;
  refreshTokenUrl: string;
  refreshToken: () => Observable<TokenResult>;
  logoutApiUrl: string;
  logout: () => void;
  authenticatedUser: AuthenticatedUser;
}

export const JWT_HTTP_INT_CONFIG = new InjectionToken<IJwtHttpIntConfig>('JwtHttpIntConfig');
export const IgnoreJwtHttpInterceptorHeader = 'IgnoreJwtHttpInterceptorHeader';

@Injectable()
export class JwtHttpIntConfigDefault implements IJwtHttpIntConfig {
  constructor(
    private userCredentialService: UserCredentialService,
    private authenticationService: AuthenticationService,
    private apiConfigService: ApiConfigService
  ) { }

  get loginUrl() {
    return this.apiConfigService.loginUrl();
  }

  get refreshTokenUrl() {
    return this.apiConfigService.refreshTokenUrl();
  }

  refreshToken() {
    return this.userCredentialService.refreshToken();
  }

  get logoutApiUrl() {
    return this.apiConfigService.logoutApiUrl();
  }

  logout() {
    this.userCredentialService.logout();
  }

  get authenticatedUser() {
    return this.authenticationService.authenticatedUser;
  }
}
